module.exports = __webpack_public_path__ + "static/img/subscribe.d163b317.png";